var map = {
	"./m1.webp": "c7e2",
	"./m2.webp": "0936",
	"./m3.webp": "5470",
	"./m4.webp": "284a",
	"./p1.webp": "faaa",
	"./p2.webp": "fd16",
	"./p3.webp": "e2c9",
	"./p4.webp": "471b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b7c";